import { render, staticRenderFns } from "./ContentDetailCopy.vue?vue&type=template&id=685391c2&scoped=true"
import script from "./ContentDetailCopy.vue?vue&type=script&lang=js"
export * from "./ContentDetailCopy.vue?vue&type=script&lang=js"
import style0 from "./ContentDetailCopy.vue?vue&type=style&index=0&id=685391c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685391c2",
  null
  
)

export default component.exports